import ButtonContainer from '@kiosk/common/components/Forms/ButtonContainer';
import Button from '@kiosk/common/components/Button';
import { useAutomatedBreaksContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/AutomatedBreaksProvider';
import { useClockedInViewContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedInViewProvider/ClockedInViewProvider';

type Props = { shortenAnimations: boolean };

const ButtonsOnClockInState = ({ shortenAnimations }: Props) => {
  const {
    canTakeMealBreak,
    canTakeRestBreak,
    setAutomatedBreakScreen,
    missedBreaks
  } = useAutomatedBreaksContext();
  const { isIntegrationKiosk, signOut, clockOut, timeClockNoteRef } = useClockedInViewContext();

  let delay = shortenAnimations ? 0 : 1;
  delay = delay + 0.4;

  const handleClockOut = () => {
    if (missedBreaks) {
      setAutomatedBreakScreen('attestation');
    } else {
      clockOut();
      timeClockNoteRef.current?.saveNote();
    }
  };

  return (
    <ButtonContainer delay={delay}>
      <>
        {(canTakeMealBreak || canTakeRestBreak) && (
          <Button
            label="Start break"
            buttonTheme="grey"
            themeColor="btnBreakTextColor"
            onPress={() => setAutomatedBreakScreen('selectAutomatedBreak')}
          />
        )}
        <Button
          label="Clock out"
          buttonTheme="grey"
          themeColor="errorTextColor"
          onPress={handleClockOut}
          withMargin
        />
        {!isIntegrationKiosk && (
          <Button label="Cancel" buttonTheme="grey" onPress={signOut} withMargin />
        )}
      </>
    </ButtonContainer>
  );
};

export default ButtonsOnClockInState;
